'use strict';

const genders = [{value: 1, label: '男'}, {value: 0, label: '女'}, {value:'', label: '不限'}],
    editGender = [{value: 1, label: '男'}, {value: 0, label: '女'}, {value: -1, label: '未知'}],
    enables = [{value: 1, label: '正常'}, {value: 0, label: '禁用'}, {value: "", label: '不限'}],
    editEnable = [{value: 1, label: '正常'}, {value: 0, label: '禁用'}];

function getSex(sex) {
    let str = '';
    switch (sex){
        case 1:
            str = "男";
            break;
        case 0:
            str = "女";
            break;
        default:
            str = "未知";
            break
    };
    return str;
}
function getStatus(status) {
    let str = '';
    switch (status){
        case 1:
            str = "正常";
            break;
        case 0:
            str = "禁用";
            break;
    };
    return str;
}

export {
    genders, enables, editGender, editEnable , getSex,getStatus
}
